import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardComponent } from '@fuse/components/card';
import { TFMService } from 'app/mock-api/tfm.service';
import { HeadingSectionType01Component } from '../../heading-section/heading_section-type01/heading_section-type01.component';
import { NgClass, NgFor, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { BlogModalComponent } from '../modals/blog-modal/blog-modal.component';
import { FooterType03Component } from "../../../../layout/common/footer/footer-type03/footer-type03.component";

@Component({
  selector: 'blog-type01',
  standalone: true,
  imports: [MatIconModule, FuseCardComponent, HeadingSectionType01Component, NgStyle, NgClass, NgFor, RouterLink, MatTooltipModule, FooterType03Component],
  templateUrl: './blog-type01.component.html',
  styleUrl: './blog-type01.component.scss'
})
export class BlogType01Component implements OnInit {

  public view: any = {
    title: '',
    isModalOpen: false,
    selectedMember: null,
    blogs : [
    {
      imageUrl: 'https://flowbite.com/docs/images/blog/image-1.jpg',
      title: 'Celestyal Itinerary Update!',
      description: 'Please take note of the following updates to Celestyal’s itineraries: Celestyal has announced the cancellation of their 14-night repositioning cruises between Athens and Doha in October 2024.',
      date: 'August 20, 2024',
      link: '#'
    },
    {
      imageUrl: 'https://flowbite.com/docs/images/blog/image-2.jpg',
      title: 'Exciting New Routes for 2025',
      description: 'Get ready for an amazing travel experience in 2025 with newly introduced routes spanning from Europe to the Middle East. Stay tuned for details!',
      date: 'September 5, 2024',
      link: '#'
    },
    {
      imageUrl: 'https://flowbite.com/docs/images/blog/image-3.jpg',
      title: 'Special Discount on Cruises!',
      description: 'Grab the opportunity to book a cruise at a special discounted rate. This offer is valid until December 31, 2024. Book now and enjoy your dream vacation!',
      date: 'August 31, 2024',
      link: '#'
    },
    // {
    //   imageUrl: 'https://flowbite.com/docs/images/blog/image-4.jpg',
    //   title: 'Safety Protocols Updated',
    //   description: 'Your safety is our priority. We’ve updated our onboard safety protocols to ensure a comfortable and safe experience for all travelers.',
    //   date: 'July 18, 2024',
    //   link: '#'
    // },
    // {
    //   imageUrl: 'https://flowbite.com/docs/images/blog/image-5.jpg',
    //   title: 'Discover Hidden Gems in the Mediterranean',
    //   description: 'Explore new destinations in the Mediterranean that are off the beaten path. Our latest itineraries will take you to secluded beaches and ancient ruins.',
    //   date: 'October 12, 2024',
    //   link: '#'
    // },
    // {
    //   imageUrl: 'https://flowbite.com/docs/images/blog/image-6.jpg',
    //   title: 'Exclusive Travel Packages for 2025',
    //   description: 'We’re introducing exclusive travel packages for 2025. Experience luxury cruises, curated activities, and gourmet dining at sea.',
    //   date: 'November 15, 2024',
    //   link: '#'
    // }
  ],
  }

  openModal(blog: any) {
    this.dialog.open(BlogModalComponent, {
      width: '1000px',
      height:'800px',
      data: blog
    });
  }


  constructor(public _tfmService: TFMService,private _cd: ChangeDetectorRef,public dialog: MatDialog) {
    
    this._tfmService.getContentBySection('about').then(res => {
      this.view.page = res;
      console.log(res);
      this._tfmService.log(this.view);

      if (this.view.page && this.view.page?.content?.images && this.view.page?.content?.images.length > 0) {
        const image = this.view.page?.content?.images[0]; // Access the first image object
        const links = image._links; // Access the _links array
      
        // Find the link with rel "view"
        const viewLink = links.find((link: any) => link.rel === "view");
      
        // Get the href if the view link exists
        if (viewLink) {
          this.view.imageHref = viewLink.href;
          this._tfmService.log("Image href:", this.view.imageHref);
          this._cd.detectChanges();
        } else {
          console.error("View link not found");
        }
      } else {
        console.error("Images not available");
      }
    });
    
    this._tfmService.getSite().then(res => {
        this.view.site = res;

        // this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        // this._tfmService.log(this.view);

       
      });
      
  }

  ngOnInit(): void {
  }
}

